module.exports = __webpack_public_path__ + "static/media/icon-mask.d85061ca.svg";